import React from 'react';

// 定义一个错误边界组件，用于捕获子组件中的错误
class ErrorBoundary extends React.Component {
    // 构造函数，初始化状态
    constructor(props) {
        super(props);
        // 初始状态设置为没有错误
        this.state = { hasError: false };
    }

    // 当子组件抛出错误时，更新状态以指示发生了错误
    static getDerivedStateFromError(error) {
        // 返回新的状态，表示发生了错误
        return { hasError: true };
    }

    // 组件捕获错误后调用的方法
    componentDidCatch(error, errorInfo) {
        // 在控制台输出错误信息和错误信息的附加信息
        console.error('Error caught by boundary:', error, errorInfo);
    }

    // 渲染方法
    render() {
        // 如果发生了错误，渲染错误提示界面
        if (this.state.hasError) {
            return (
                <div className="error-container p-4 text-center">
                    <h2>页面加载出错</h2>
                    <button
                        className="btn btn-primary mt-3"
                        // 点击按钮时刷新页面
                        onClick={() => window.location.reload()}
                    >
                        刷新页面
                    </button>
                </div>
            );
        }

        // 如果没有错误，渲染子组件
        return this.props.children;
    }
}

// 导出错误边界组件
export default ErrorBoundary;
